import AppConstants from 'constants/AppConstants';

interface KeyboardShortcutState {
  enableChangeDatesInCalendar: boolean;
}

const initialState: KeyboardShortcutState = {
  enableChangeDatesInCalendar: true,
};

export default function reducer(
  state = initialState,
  action: BaseTockAction
): KeyboardShortcutState {
  const { type } = action;
  switch (type) {
    case AppConstants.KEYBOARD_SHORTCUTS_OPEN_MODAL: {
      return {
        ...state,
        enableChangeDatesInCalendar: false,
      };
    }
    case AppConstants.KEYBOARD_SHORTCUTS_CLOSE_MODAL: {
      return {
        ...state,
        enableChangeDatesInCalendar: true,
      };
    }
    default:
      return state;
  }
}
